export const mdBreakpoint = 1100
export const smBreakpoint = 768
export const xsBreakpoint = 550
export const windowWidth = window.innerWidth
